module.exports = __webpack_public_path__ + "img/ic_gift_voucher.461307ba.svg";